export const FEEDBACK_MOODS = [
  { mood: 'smiling', emoji: '☺️' },
  { mood: 'smallsmile', emoji: '🙂' },
  { mood: 'star', emoji: '🤩' },
  { mood: 'bageyes', emoji: '🫩' },
  { mood: 'neutral', emoji: '😐' },
  { mood: 'confused', emoji: '😕' },
  { mood: 'zany', emoji: '🤪' },
  { mood: 'partying', emoji: '🥳' },
  { mood: 'nerd', emoji: '🤓' },
  { mood: 'grimacing', emoji: '😬' },
  { mood: 'upsidedown', emoji: '🙃' },
  { mood: 'grinning', emoji: '😃' },
] as const;

export type FeedbackMood = (typeof FEEDBACK_MOODS)[number]['mood'];

export const FEEDBACK_MOOD_EMOJI: Record<FeedbackMood, string> = Object.fromEntries(
  FEEDBACK_MOODS.map(({ mood, emoji }) => [mood, emoji]),
) as Record<FeedbackMood, string>;
